import styles from '../fanfic-landing.module.css'

type SectionLabelProps = {
  text: string
  centered?: boolean
  className?: string
}

export function SectionLabel({ text, centered = false, className }: SectionLabelProps) {
  const classes = [styles.sectionLabel, centered ? styles.centered : '', className ?? '']
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classes} data-reveal="true">
      <div className={styles.sectionLabelStars} aria-hidden="true">
        <span className={styles.sectionLabelStar}>✦</span>
      </div>
      <span>{text}</span>
    </div>
  )
}
